import { jsx as _jsx } from "react/jsx-runtime";
import DraggableBox from "../DraggableBox";
const DraggableDiv = ({ id, props, children, elementId, ...rest }) => {
    return (_jsx(DraggableBox, { className: props?.className, "editor-key": id, draggableId: id, focusKey: id, elementId: elementId, childs: children, component: props?.component || "div", "editor-background-image-src": props?.backgroundImage?.src, "editor-background-image-file": props?.backgroundImage?.file, style: {
            ...(props?.backgroundImage && {
                backgroundImage: `url(${props?.backgroundImage?.src})`,
            }),
        }, ...props, ...rest }));
};
export default DraggableDiv;
//# sourceMappingURL=DraggableDiv.js.map